/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  Select,
  OutlinedInput,
  Box,
  Chip,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

const CssFormControl = styled(FormControl)({
  '& label.Mui-focused': {
    color: '#84d8c5',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#84d8c5',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#84d8c5',
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(item, itemName, theme) {
  return {
    fontWeight:
      itemName.indexOf(item) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export const MultiSelect = (props) => {
  const theme = useTheme();

  return (
    <CssFormControl fullWidth margin="normal" required={props.required}>
      <InputLabel>{props.label}</InputLabel>
      <Select
        multiple
        value={props.value}
        onChange={props.onChange}
        input={<OutlinedInput label={props.label} />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value, index) => (
              <Chip key={index} label={value} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {props.items.map((item, index) => (
          <MenuItem
            key={index}
            // value={[item.id, item.name]}
            value={item.name}
            style={getStyles(item.name, props.itemName, theme)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </CssFormControl>
  );
};
